// src/pages/Florals/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "../CollectionPage";
import { getFlorals, PRODUCTS_PER_PAGE } from "../../data/florals";

export default function Florals() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getFlorals()
      .then(setProducts)
      .catch(err => setError(err.message || "Failed to load products"));
  }, []);

  if (error) {
    return <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>;
  }
  if (!products) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/florals",
    announcement: {
      headline: "New: Florals in Notebooks — nature on every page!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Florals in Notebooks",
      subtitle: "Beautiful botanical notebooks",
     featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "The most beautiful notebook I've ever owned — the illustrations are absolutely stunning.",
      quoteLink: "#",
      rating: "4.8",
      ratingCount: "1000+",
    },
  };

  return <CollectionPage config={config} />;
}